import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EllipsisFinderDirective } from './ellipsis-finder.directive';
import { NumberOnlyDirective } from './numbers-only.directive';
import { InputTrimDirective } from './input-trim.directive';
import { InputValidationGeneralDirective } from './input-validation-general.directive';
import { ClickOutside } from './outside-click.directive';
import { OnCreate } from './element-init-checker.directive';
import { EscapeCountryCode } from './escape-countrycode-delete.directive';
import { AppColor } from './app-color.directive';
import { PreventEmoteDirective } from './prevent-emote.directive'


@NgModule({
    imports: [],
    declarations: [
        EllipsisFinderDirective,
        NumberOnlyDirective,
        InputTrimDirective,
        OnCreate,
        ClickOutside,
        EscapeCountryCode,
        AppColor,
        PreventEmoteDirective,
        InputValidationGeneralDirective
    ],
    providers: [],
    exports: [
        EllipsisFinderDirective,
        NumberOnlyDirective,
        InputTrimDirective,
        OnCreate,
        ClickOutside,
        EscapeCountryCode,
        AppColor,
        PreventEmoteDirective,
        InputValidationGeneralDirective
    ]
})

export class DirectivesModule { }